import React, { useState, useEffect } from "react";
import TopToolbar from "../components/TopToolbar.jsx"; // 導入 TopToolbar

function App() {
    const [displayedData, setDisplayedData] = useState([]);


    const [data, setData] = useState([]); // 存儲表格數據
    const [editingRow, setEditingRow] = useState(null); // 當前正在編輯的行
    const [editedRow, setEditedRow] = useState({}); // 編輯中的行數據
    const [showDeleteModal, setShowDeleteModal] = useState(false); // 是否顯示刪除確認
    const [deleteEmail, setDeleteEmail] = useState(""); // 要刪除的行的 email
    const [expiredData, setExpiredData] = useState([]); // 過期數據
    const [showExpired, setShowExpired] = useState(false); // 控制是否顯示過期數據
    const [checkInToday, setCheckInToday] = useState([]); // Check-In Today
    const [checkOutToday, setCheckOutToday] = useState([]); // Check-Out Today

    const API_URL = "https://hocyc82op1.execute-api.ap-southeast-1.amazonaws.com/checkin";
    const AUTH_HEADER = {
        Authorization: "Bearer RaXc*lq3j5=1w<$rD^C+}VGvZVi]=dWN}P}(^~XK;h6%O@D;KkqKm~uU>+f,dqY",
        "Content-Type": "application/json",
    };

    const getGMT8Date = () => {
        const now = new Date();
        const gmt8Offset = 8 * 60 * 60 * 1000; // GMT+8 的偏移量（毫秒）
        const gmt8Date = new Date(now.getTime() + gmt8Offset);
        return gmt8Date.toISOString().split("T")[0]; // 返回 GMT+8 的日期（格式：YYYY-MM-DD）
      };

    // 獲取數據
    const fetchData = async () => {
        try {
            const response = await fetch(`${API_URL}/read`, {
                method: "GET",
                headers: AUTH_HEADER,
            });
            const result = await response.json();
            const today = new Date().toISOString().split("T")[0];
            const todayGMT8 = getGMT8Date(); // 獲取 GMT+8 的當前日期

            // 將數據存入本地狀態
            const formattedData = result.map((row) => ({
                ...row,
                remarks: row.remarks || "", // 新增 remarks 字段，默認值為空字符串
            }));

            setData(formattedData);

            // 過期數據：Check-In 和 Check-Out 都已過去
            setExpiredData(
                formattedData.filter(
                    (row) => row.checkOutDate < todayGMT8 && row.checkInDate < todayGMT8
                )
            );

            // Check-In Today
            setCheckInToday(formattedData.filter((row) => row.checkInDate === todayGMT8));

            // Check-Out Today
            setCheckOutToday(formattedData.filter((row) => row.checkOutDate === todayGMT8));
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    // 刪除行
    const handleDelete = async () => {
        try {
            const response = await fetch(`${API_URL}/delete`, {
                method: "DELETE",
                headers: AUTH_HEADER,
                body: JSON.stringify({ email: deleteEmail }),
            });
            if (response.ok) {
                alert("Data successfully deleted!");
                setData(data.filter((row) => row.email !== deleteEmail)); // 更新本地數據
            } else {
                alert("Failed to delete the data.");
            }
        } catch (error) {
            console.error("Error deleting data:", error);
        } finally {
            setShowDeleteModal(false); // 關閉刪除確認視窗
        }
    };

    // 編輯按鈕
    const handleEdit = (row) => {
        setEditingRow(row.email); // 設置當前正在編輯的行
        setEditedRow({ ...row }); // 加載行數據到編輯狀態
    };

    // 保存編輯
    const handleSaveEdit = async () => {
        try {
            const response = await fetch(`${API_URL}/edit`, {
                method: "POST",
                headers: AUTH_HEADER,
                body: JSON.stringify(editedRow),
            });
            if (response.ok) {
                alert("Data successfully updated!");
                setData(
                    data.map((row) =>
                        row.email === editedRow.email ? editedRow : row
                    )
                ); // 更新本地數據
                setEditingRow(null); // 清空編輯狀態
            } else {
                alert("Failed to update the data.");
            }
        } catch (error) {
            console.error("Error updating data:", error);
        }
    };

    // 處理編輯中的輸入變更
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setEditedRow((prev) => ({ ...prev, [name]: value }));
    };

    // 初始化數據
    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        setDisplayedData(checkInToday); // 初始化顯示 Check-In Today
    }, [checkInToday]);


    

    return (
        <div style={styles.container}>
            <TopToolbar /> {/* 使用 TopToolbar */}
            <div style={styles.toolbar}>
                <button
                    style={styles.toolbarButton_green}
                    onClick={() => setDisplayedData(checkInToday)}
                >
                    Check-In Today
                </button>
                <button
                    style={styles.toolbarButton_red}
                    onClick={() => setDisplayedData(checkOutToday)}
                >
                    Check-Out Today
                </button>
                <button
                    style={styles.toolbarButton_yellow}
                    onClick={() => {
                        if (showExpired) {
                            setDisplayedData(checkInToday); // 切回 Check-In Today
                        } else {
                            setDisplayedData(expiredData); // 顯示過期數據
                        }
                        setShowExpired(!showExpired); // 切換過期數據顯示狀態
                    }}
                >
                    {showExpired ? "Hide Expired" : "Show Expired"}
                </button>
                <button
                    style={styles.toolbarButton_dark_blue}
                    onClick={() => setDisplayedData(data)} // Show all data
                >
                    Show All
                </button>
            </div>
            <h1 style={styles.heading}>Check-In System</h1>
            <div style={styles.table}>
                {displayedData.map((row) => (
                    <div key={row.email} style={styles.row}>
                        {/* 左側的刪除按鈕 */}
                        <button
                            onClick={() => {
                                setShowDeleteModal(true);
                                setDeleteEmail(row.email);
                            }}
                            style={styles.deleteButton}
                        >
                            ×
                        </button>

                        {/* 顯示完整數據或編輯模式 */}
                        {editingRow === row.email ? (
                            // 編輯模式
                            <div style={{ flex: 1 }}>
                                <input
                                    type="text"
                                    name="name"
                                    value={editedRow.name}
                                    onChange={handleInputChange}
                                    style={styles.input}
                                    placeholder="Name"
                                />
                                <input
                                    type="text"
                                    name="email"
                                    value={editedRow.email}
                                    onChange={handleInputChange}
                                    style={styles.input}
                                    placeholder="Email"
                                />
                                <input
                                    type="text"
                                    name="gender"
                                    value={editedRow.gender}
                                    onChange={handleInputChange}
                                    style={styles.input}
                                    placeholder="Gender"
                                />
                                <input
                                    type="text"
                                    name="nationality"
                                    value={editedRow.nationality}
                                    onChange={handleInputChange}
                                    style={styles.input}
                                    placeholder="Nationality"
                                />
                                <input
                                    type="date"
                                    name="birthday"
                                    value={editedRow.birthday}
                                    onChange={handleInputChange}
                                    style={styles.input}
                                    placeholder="Birthday"
                                />
                                <input
                                    type="time"
                                    name="sleepTime"
                                    value={editedRow.sleepTime}
                                    onChange={handleInputChange}
                                    style={styles.input}
                                    placeholder="Sleep Time"
                                />
                                <input
                                    type="time"
                                    name="wakeUpTime"
                                    value={editedRow.wakeUpTime}
                                    onChange={handleInputChange}
                                    style={styles.input}
                                    placeholder="Wake Up Time"
                                />
                                <input
                                    type="date"
                                    name="checkInDate"
                                    value={editedRow.checkInDate}
                                    onChange={handleInputChange}
                                    style={styles.input}
                                    placeholder="Check-In Date"
                                />
                                <input
                                    type="date"
                                    name="checkOutDate"
                                    value={editedRow.checkOutDate}
                                    onChange={handleInputChange}
                                    style={styles.input}
                                    placeholder="Check-Out Date"
                                />
                                <input
                                    type="time"
                                    name="checkOutTime"
                                    value={editedRow.checkOutTime}
                                    onChange={handleInputChange}
                                    style={styles.input}
                                    placeholder="Check-Out Time"
                                />
                                <input
                                    type="text"
                                    name="sleepProblem"
                                    value={editedRow.sleepProblem}
                                    onChange={handleInputChange}
                                    style={styles.input}
                                    placeholder="Sleep Problem"
                                />
                                <input
                                    type="text"
                                    name="sleepSolution"
                                    value={editedRow.sleepSolution}
                                    onChange={handleInputChange}
                                    style={styles.input}
                                    placeholder="Sleep Solution"
                                />
                                <input
                                    type="text"
                                    name="useAroma"
                                    value={editedRow.useAroma}
                                    onChange={handleInputChange}
                                    style={styles.input}
                                    placeholder="Use Aroma"
                                />
                                <input
                                    type="text"
                                    name="travelWith"
                                    value={editedRow.travelWith}
                                    onChange={handleInputChange}
                                    style={styles.input}
                                    placeholder="Travel With"
                                />
                                <input
                                    type="text"
                                    name="hotelName"
                                    value={editedRow.hotelName}
                                    onChange={handleInputChange}
                                    style={styles.input}
                                    placeholder="Hotel Name"
                                />
                                <input
                                    type="text"
                                    name="roomNumber"
                                    value={editedRow.roomNumber}
                                    onChange={handleInputChange}
                                    style={styles.input}
                                    placeholder="Room Number"
                                />
                                <input
                                    type="text"
                                    name="mobileNumber"
                                    value={editedRow.mobileNumber}
                                    onChange={handleInputChange}
                                    style={styles.input}
                                    placeholder="Mobile Number"
                                />
                                <input
                                    type="text"
                                    name="handleBy"
                                    value={editedRow.handleBy}
                                    onChange={handleInputChange}
                                    style={styles.input}
                                    placeholder="Handle By"
                                />
                                <input
                                    type="text"
                                    name="otherHandleBy"
                                    value={editedRow.otherHandleBy}
                                    onChange={handleInputChange}
                                    style={styles.input}
                                    placeholder="Other Handle By"
                                />

                                <input
                                    type="text"
                                    name="remarks"
                                    value={editedRow.remarks}
                                    onChange={handleInputChange}
                                    style={styles.input}
                                    placeholder="Remarks"
                                />



                                {/* 保存和取消修改按鈕 */}
                                <button onClick={handleSaveEdit} style={styles.saveButton}>
                                    Save
                                </button>
                                <button
                                    onClick={() => setEditingRow(null)} // 退出編輯模式
                                    style={styles.cancelButton}
                                >
                                    Cancel
                                </button>
                            </div>
                        ) : (
                            // 顯示模式
                            <div style={{ flex: 1 }}>
                                <p><strong>Name:</strong> {row.name}</p>
                                <p><strong>Email:</strong> {row.email}</p>
                                <p><strong>Gender:</strong> {row.gender}</p>
                                <p><strong>Nationality:</strong> {row.nationality}</p>
                                <p><strong>Birthday:</strong> {row.birthday}</p>
                                <p><strong>Sleep Time:</strong> {row.sleepTime}</p>
                                <p><strong>Wake Up Time:</strong> {row.wakeUpTime}</p>
                                <p><strong>Check-In Date:</strong> {row.checkInDate}</p>
                                <p><strong>Check-Out Date:</strong> {row.checkOutDate}</p>
                                <p><strong>Check-Out Time:</strong> {row.checkOutTime}</p>
                                <p><strong>Sleep Problem:</strong> {row.sleepProblem}</p>
                                <p><strong>Sleep Solution:</strong> {row.sleepSolution}</p>
                                <p><strong>Use Aroma:</strong> {row.useAroma}</p>
                                <p><strong>Travel With:</strong> {row.travelWith}</p>
                                <p><strong>Hotel Name:</strong> {row.hotelName}</p>
                                <p><strong>Room Number:</strong> {row.roomNumber}</p>
                                <p><strong>Mobile Number:</strong> {row.mobileNumber}</p>
                                <p><strong>Handle By:</strong> {row.handleBy}</p>
                                <p><strong>Other Handle By:</strong> {row.otherHandleBy}</p>
                                <p><strong>Remarks:</strong> {row.remarks}</p>
                            </div>
                        )}

                        {/* 右側的編輯按鈕 */}
                        {!editingRow && (
                            <button onClick={() => handleEdit(row)} style={styles.editButton}>
                                Edit
                            </button>
                        )}
                    </div>
                ))}
            </div>

            {/* 刪除確認視窗 */}
            {showDeleteModal && (
                <div style={styles.modal}>
                    <div style={styles.modalContent}>
                        <p>Are you sure you want to delete this record?</p>
                        <div style={styles.modalButtons}>
                            <button
                                onClick={() => setShowDeleteModal(false)}
                                style={styles.cancelButton}
                            >
                                Cancel
                            </button>
                            <button onClick={handleDelete} style={styles.confirmButton}>
                                Confirm
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

const styles = {
    container: {
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "#f7f9fc",
        fontFamily: "Arial, sans-serif",
        padding: "20px",
    },
    heading: {
        fontSize: "24px",
        fontWeight: "bold",
        marginBottom: "20px",
    },
    table: {
        width: "100%",
        maxWidth: "600px",
        background: "#fff",
        borderRadius: "8px",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
        overflow: "hidden",
    },
    row: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "10px 10px 10px 50px",
        borderBottom: "1px solid #ddd",
        position: "relative",
    },
    deleteButton: {
        position: "absolute",
        left: "10px",
        background: "#ff4d4f",
        color: "#fff",
        border: "none",
        borderRadius: "50%",
        width: "30px",
        height: "30px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: "bold",
        fontSize: "16px",
        cursor: "pointer",
    },
    editButton: {
        background: "#007bff",
        color: "#fff",
        border: "none",
        borderRadius: "4px",
        padding: "5px 15px",
        cursor: "pointer",
    },
    saveButton: {
        background: "#28a745",
        color: "#fff",
        border: "none",
        borderRadius: "4px",
        padding: "5px 10px",
        cursor: "pointer",
    },
    cancelButton: {
        background: "#6c757d",
        color: "#fff",
        border: "none",
        borderRadius: "4px",
        padding: "5px 10px",
        cursor: "pointer",
        marginLeft: "10px",
    },
    input: {
        flex: 1,
        marginBottom: "10px",
        padding: "5px",
        border: "1px solid #ccc",
        borderRadius: "4px",
    },
    modal: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    modalContent: {
        background: "#fff",
        padding: "20px",
        borderRadius: "8px",
        textAlign: "center",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
    },
    modalButtons: {
        display: "flex",
        justifyContent: "space-around",
        marginTop: "20px",
    },
    cancelButton: {
        background: "#ddd",
        padding: "10px 20px",
        borderRadius: "4px",
        border: "none",
        cursor: "pointer",
    },
    confirmButton: {
        background: "#ff4d4f",
        color: "#fff",
        padding: "10px 20px",
        borderRadius: "4px",
        border: "none",
        cursor: "pointer",
    },
    toolbar: {
        display: "flex",
        justifyContent: "center",
        marginBottom: "20px",
        gap: "10px",
    },
    toolbarButton: {
        background: "#007bff",
        color: "#fff",
        border: "none",
        borderRadius: "4px",
        padding: "10px 20px",
        cursor: "pointer",
        fontSize: "14px",
        fontWeight: "bold",
    },
    toolbarButton_red: {
        background: "#e07a5f",
        color: "#fff",
        border: "none",
        borderRadius: "4px",
        padding: "10px 20px",
        cursor: "pointer",
        fontSize: "14px",
        fontWeight: "bold",
    },
    toolbarButton_green: {
        background: "#81b29a",
        color: "#fff",
        border: "none",
        borderRadius: "4px",
        padding: "10px 20px",
        cursor: "pointer",
        fontSize: "14px",
        fontWeight: "bold",
    },
    toolbarButton_yellow: {
        background: "#f2cc8f",
        color: "#fff",
        border: "none",
        borderRadius: "4px",
        padding: "10px 20px",
        cursor: "pointer",
        fontSize: "14px",
        fontWeight: "bold",
    },
    toolbarButton_dark_blue: {
        background: "#3d405b",
        color: "#fff",
        border: "none",
        borderRadius: "4px",
        padding: "10px 20px",
        cursor: "pointer",
        fontSize: "14px",
        fontWeight: "bold",
    },
};

export default App;